// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Ca129","title":"Info_title__TMeXF","links":"Info_links__1nONU","link":"Info_link__uZnV5","logo":"Info_logo__18S8-"};